import { _axiosCall } from '../../helpers/apicalls';
import { buildingExportFL, propertyExportFL } from '../../helpers/utils';

const apiUrl = process.env.API_ROOT + '/buyerslist/';

export const Marketproof = (function () {

  var DEDUP_TTL = 5000; // 5 seconds

  // Lightweight checksum
  function simpleChecksum(obj) {
	var str = JSON.stringify(obj || {});
	var hash = 0;
	for (var i = 0; i < str.length; i++) {
	  hash = (hash << 5) - hash + str.charCodeAt(i);
	  hash |= 0; // Convert to 32bit integer
	}
	return hash.toString();
  }

  // Deduplication check
  function isDuplicateEvent(event_type, event_sub_type, user, data) {
	try {
	  var userId = (user && (user.id || user.email)) ? (user.id || user.email) : "anon";

	  // Include only essential data for checksum
	  var dedupData = {
		building: (data && data.building && data.building.id) ? data.building.id : null,
		property: (data && data.property && data.property.id) ? data.property.id : null,
		report: (data && data.report) ? data.report : null,
		customData: (data && data.customData) ? data.customData : null
	  };

	  var checksum = simpleChecksum(dedupData);
	  var dedupKey = 'mp_event_' + userId + '_' + event_type + '_' + event_sub_type + '_' + checksum;
	  var now = Date.now();
	  var lastTracked = localStorage.getItem(dedupKey);

	  if (lastTracked && now - parseInt(lastTracked, 10) < DEDUP_TTL) {
		return true; // Duplicate within TTL
	  }

	  localStorage.setItem(dedupKey, now);
	  return false;
	} catch (e) {
	  return false; // Fail open if localStorage unavailable
	}
  }

  function sanitizeObject(data, trackedKeys) {
	if (!data || typeof data !== "object") return false;

	var keyArray = ["key", "id", "user_key"];
	var sanitized = {};
	Object.keys(data).forEach(function (key) {
	  if (trackedKeys.indexOf(key) >= 0 || keyArray.indexOf(key) >= 0) {
		if (data[key]) {
		  if (Array.isArray(data[key]) && data[key][0]) {
			sanitized[key] = keyArray.indexOf(key) < 0
			  ? data[key][0].toString().toLowerCase()
			  : data[key][0];
		  } else {
			sanitized[key] = keyArray.indexOf(key) < 0
			  ? data[key].toString().toLowerCase()
			  : data[key];
		  }
		}
	  }
	});
	return sanitized;
  }

  function trackEvent(event, data) {
	console.log('trackEvent', event, data);

	// Skip localhost tracking
	if (window.location.hostname.indexOf('localhost') >= 0) return false;

	var events = event.split(".");
	if (events[0] === 'track-mp') events.shift();
	var event_type = events[0];
	var event_sub_type = events[1] || null;

	// Deduplication check
	if (isDuplicateEvent(event_type, event_sub_type, data.user, data)) {
	  console.log("Duplicate event skipped:", event_type, event_sub_type);
	  return false;
	}

	// Optional: legacy URL-based duplication check
	if (data.checkDupURL && window && window.location && window.location.href) {
	  if (window.last_tracked_mp_url === window.location.href) return false;
	}

	var user = data.user;
	var building = data.building;
	var property = data.property;
	var report = data.report;
	var customData = data.customData;

	var trackedUserKeys = ["email", "id", "firstName", "lastName"];

	var sanitizedUser = sanitizeObject(user, trackedUserKeys);
	var sanitizedBuilding = sanitizeObject(building, buildingExportFL);
	var sanitizedProperty = sanitizeObject(property, propertyExportFL);

	var saveData = {
	  event_type: event_type,
	  event_sub_type: event_sub_type,
	  user: sanitizedUser,
	  building: sanitizedBuilding,
	  property: sanitizedProperty,
	  report: report || false,
	  custom_data: customData || false,
	  source: "MPND"
	};

	console.log("saveData", saveData);
	var apiData = {
	  url: apiUrl + 'event/track',
	  method: "post",
	  query: saveData
	};

	_axiosCall(apiData)
	  .then(function (res) {
		console.log(res);
		if (window && window.location && window.location.href) {
		  window.last_tracked_mp_url = window.location.href;
		  console.log("store mp url", window.last_tracked_mp_url);
		}
	  });
  }

  return {
	trackEvent: trackEvent
  };
})();
